import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiSchemaSettings, StrapiSingleResponse } from '@ts-strapi/interfaces'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface UseStrapiSchemaSettingsReturn {
  refSchemaSettings: ComputedRef<StrapiSchemaSettings | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiSchemaSettings = async (): Promise<UseStrapiSchemaSettingsReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:schema-settings',
    () => strapiFetch<StrapiSingleResponse<StrapiSchemaSettings>>('/schema-setting', {
      params: {
        'populate[address]': 'true',
        'populate[contactPoints]': 'true',
      },
    }),
  )

  return {
    refSchemaSettings: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
